import { useMemo } from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { is1PMacro } from '@confluence/fabric-extension-lib/entry-points/macroClassificationUtils';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';
import { fg } from '@confluence/feature-gating';

export const useShouldHideOverlay = (extensionKey: string, isBodiedExtension: boolean): boolean => {
	const isLivePage = useIsCurrentPageLive();

	const shouldHideV1: boolean = useMemo(() => {
		const extensionsToHideOverlays = StatsigConfigurations.getStringList(
			'confluence_frontend_extension_overlay_removal_list',
			[],
		);

		if (!extensionKey || extensionsToHideOverlays.length === 0) {
			return false;
		}

		if (extensionsToHideOverlays[0] === 'ALLOW_ALL' || isLivePage) {
			return true;
		}

		const is2PNonBodied = !is1PMacro(extensionKey) && !isBodiedExtension;
		if (is2PNonBodied) {
			return true;
		}

		const extensionKeys = extensionsToHideOverlays.map((ext) => ext.trim().toLowerCase());

		return extensionKeys.includes(extensionKey.toLowerCase());
	}, [extensionKey, isLivePage, isBodiedExtension]);

	const shouldHideV2: boolean = useMemo(() => {
		if (!extensionKey) {
			return false;
		}

		const is2PNonBodied = !is1PMacro(extensionKey) && !isBodiedExtension;
		if (is2PNonBodied || isLivePage) {
			return true;
		}

		const extensionsToHideOverlays = StatsigConfigurations.getStringList(
			'confluence_frontend_extension_overlay_removal_list',
			[],
		);

		if (extensionsToHideOverlays.length === 0) {
			return false;
		}

		if (extensionsToHideOverlays[0] === 'ALLOW_ALL') {
			return true;
		}

		const extensionKeys = extensionsToHideOverlays.map((ext) => ext.trim().toLowerCase());

		return extensionKeys.includes(extensionKey.toLowerCase());
	}, [extensionKey, isLivePage, isBodiedExtension]);

	return fg('confluence_macro_overlay_2p_logic_change') ? shouldHideV2 : shouldHideV1;
};
